export default __webpack_public_path__ + "static/media/25120402.12fd7164.jpg";